const initialState = {
  pending: null,
  items: [],
  chosen: {},
  chosenCalibration: {}
};

export default function recorders(state = initialState, action) {
  let chosenCalibration = {};

  switch (action.type) {
    case 'GET_RECORDERS_START':
      return { ...state,
        ...{ pending: true }
      };
    case 'GET_RECORDERS_FAIL':
    case 'GET_RECORDERS_FAIL_PARSE':
    case 'GET_RECORDERS_FAIL_REQUEST':
      return { ...state,
        ...{ pending: null }
      };
    case 'GET_RECORDERS_COMPLETE':
      if (action.payload.response[0]
        && action.payload.response[0].calibrations
        && (action.payload.response[0].calibrations.length > 0)
      ) {
        chosenCalibration = action.payload.response[0].calibrations[0];
      }

      return { ...state, ...{
        pending: false,
        items: action.payload.response,
        chosen: action.payload.response[0] || {},
        chosenCalibration: chosenCalibration
      }};
    case 'CHOOSE_RECORDER':
      if (action.payload.calibrations
        && (action.payload.calibrations.length > 0)
      ) {
        chosenCalibration = action.payload.calibrations[0];
      }

      return { ...state, ...{
        chosen: action.payload,
        chosenCalibration: chosenCalibration
      }};
    case 'CHOOSE_CALIBRATION':
      return { ...state, ...{
        chosenCalibration: action.payload
      }};
    default:
      return state;
  }
}
